import { CellValue } from 'handsontable';

// Generic to preserve the caller's value type; widening to CellValue (unknown in v18) breaks string/number callers.
export const removeComma = <T>(value: T): T => {
  if (value === null || value === undefined) {
    return value;
  }
  return (typeof value === 'string' ? value.replaceAll(',', '').trim() : value) as T;
};

export const isNumericEmpty = (value: CellValue): boolean => {
  if (value === null || value === undefined) {
    return true;
  }
  const sanitized = removeComma(value);

  if (typeof sanitized === 'string' && !sanitized.length) {
    return true;
  }
  return false;
};

export const isGreaterThanOrEqualToZero = (value: CellValue, allowEmpty: boolean): boolean => {
  if (isNumericEmpty(value)) {
    return allowEmpty;
  }
  return Number(removeComma(value)) >= 0;
};
